const isProd = process.env.NODE_ENV !== 'development';

export const API_URL_BASE = isProd ? 'https://api.onino.com.br' : 'http://localhost:9001';
